export const defaultValues = {
  name: "",
  gender: "",
  birth_date: "",
  height: "",
  current_weight: "",
  desired_weight: "",
  health_pov: "",
  activity_level: "",
  sleep_problems: "",
  morning_fatigue: "",
  digestion_problems: "",
  diets_number: "",
  email: "",
  phone: "",
  agreementCheck: false,
};
